import { Component, OnInit, ViewChild } from '@angular/core';
import { ApplicantService } from '../../../applicant.service';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent implements OnInit
{
  @ViewChild('fileUpload') fileUploadRef!: FileUpload;

  /** Muvaffaqiyatli yuklangan fayllar ro'yxati (sessiya davomida — yopilishdan oldin). */
  uploadedFiles: { fileOriginalName: string; spFileTypeId: number }[] = [];

  /** Hozirgi tanlangan fayl turi. */
  currentSpFileTypeId: number | null = null;

  /** Upload jarayonida. */
  uploadInProgress = false;

  constructor(public applicantService: ApplicantService) { }

  ngOnInit(): void { }

  private readonly maxFileSizeBytes = 10 * 1024 * 1024; // 10 MB

  /** Fayl tanlanganda — yuklash boshlanadi. */
  onFileSelect(event: { files: File[] }): void
  {
    if (!this.currentSpFileTypeId)
    {
      this.applicantService.primeToast('error', 'application.select_file_type_first');
      this.clearFileUpload();
      return;
    }
    if (!event.files?.length)
      return;

    if (event.files[0].size > this.maxFileSizeBytes)
    {
      this.applicantService.primeToast('error', 'vacancy.max_file_size_is_10mb');
      this.clearFileUpload();
      return;
    }

    this.uploadInProgress = true;

    this.applicantService
      .uploadApplicantFile(event.files, this.currentSpFileTypeId)
      .subscribe({
        next: (result) =>
        {
          this.uploadInProgress = false;
          if (result)
          {
            this.applicantService.primeToast('success', 'applicant.file_has_been_uploaded');
            this.applicantService.ref.close(true);
            return;
          }
          this.applicantService.primeToast('error', 'applicant.file_could_not_be_uploaded');
          this.clearFileUpload();
        },
        error: () =>
        {
          this.uploadInProgress = false;
          this.applicantService.primeToast('error', 'applicant.file_could_not_be_uploaded');
          this.clearFileUpload();
        },
      });
  }

  /** Xato yoki rad etilganda tugmadagi fayl nomini olib tashlash. */
  private clearFileUpload(): void
  {
    setTimeout(() => this.fileUploadRef?.clear(), 0);
  }

  onDialogClose(): void
  {
    this.applicantService.ref.close();
  }

  /** Yangi upload qatori ko'rinadimi — fayl turlari tugamaguncha true. */
  get showUploadRow(): boolean
  {
    const max = this.applicantService.spService.spApplicantFileTypes.filter(
      x => x.value != ''
    ).length;
    return this.uploadedFiles.length < max;
  }

  /** Fayl turi nomini olish. */
  getFileTypeLabel(spFileTypeId: number): string
  {
    return this.applicantService.spService.getLabelByValue(
      this.applicantService.spService.spApplicantFileTypes,
      spFileTypeId
    );
  }
}
